import React, { lazy, Suspense, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./layout/Header";
import { useContext, useEffect, useRef } from "react";
import Footer from "./layout/Footer";
import { setCookie, getCookie } from "./Components/Service/utils";
import { useLocation } from 'react-router-dom';
import { CartProvider } from "./Components/Service/CartContext";


const LazyHomePage = lazy(() => import("./pages/HomePage"));
const LazyProducts = lazy(() => import("./pages/Products"));
const LazyShopDhanvi = lazy(() => import("./pages/ShopDhanvi"));
const LazyShopPremio = lazy(() => import("./pages/ShopPremio"));
const LazyProductDetail = lazy(() => import("./pages/ProductDetail"));
const LazyCategories = lazy(() => import("./pages/Categories"));
const LazyLogin = lazy(() => import("./pages/Login"));
const LazyForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const LazyNewPassword = lazy(() => import("./pages/NewPassword"));
// const LazySizeGuide = lazy(() => import("./pages/SizeGuide"));
const LazyAbout = lazy(() => import("./pages/About"));
// const LazyAboutDhanvi = lazy(() => import("./pages/AboutDhanvi")); 
const LazyBespoke = lazy(() => import("./pages/Bespoke"));
const LazyContact = lazy(() => import("./pages/Contact"));
const LazyCartWishList = lazy(() => import("./pages/WishList"));
const LazyCart = lazy(() => import("./pages/Cart"));
const LazyPage = lazy(() => import("./pages/Page"));
const LazyBlog = lazy(() => import("./pages/Blog"));
const LazyBlogsDetail = lazy(() => import("./pages/BlogDetail"));
// const LazyFaqs = lazy(() => import("./pages/Faqs"));
// const LazyJewelleryCare = lazy(() => import("./pages/JewelleryCare"));
const LazySearch = lazy(() => import("./common/Search"));
const LazySearchList = lazy(() => import("./common/SearchList"));
const LazyCheckout = lazy(() => import("./pages/Checkout"));
// const LazyFranchise = lazy(() => import("./pages/Franchise"));
const LazyTrade = lazy(() => import("./pages/Trade"));
const LazyTestimonial = lazy(() => import("./pages/Testimonial"));
const LazyMyAccount = lazy(() => import("./pages/account/MyAccount"));
const LazyMyOrders = lazy(() => import("./pages/account/MyOrders"));
const LazyMyWishlist = lazy(() => import("./pages/account/MyWishlist"));
const LazyAddressBook = lazy(() => import("./pages/account/AddressBook"));
const LazyAccountInformation = lazy(() => import("./pages/account/AccountInformation"));
const LazyChangePassword = lazy(() => import("./pages/account/ChangePassword"));
const LazyBLogin = lazy(() => import("./businesslogin/BLogin"));
const LazyBSignup = lazy(() => import("./businesslogin/BSignup"));
const LazyWishList = lazy(() => import("./pages/WishList"));
const LazyThankyou = lazy(() => import("./pages/thankyou"));
const LazyPurchaseOrder = lazy(() => import("./pages/PurchaseOrder"));
const LazyEventListing = lazy(() => import("./pages/EventListing"));
const LazyEventDetail = lazy(() => import("./pages/EventDetail"));
const LazySubCategories = lazy(() => import("./pages/Subcategories"));

function App() {
  const location = useLocation();
  const [cartshow, setcartShow] = useState(false);
  const didMountRef = useRef(true);
  const carthandleClose = () => setcartShow(false);
  const carthandleShow = () => setcartShow(true);
  const [isSearchPage, setIsSearchPage] = useState(false);
  useEffect(() => {

    if (location.pathname == "/search") {
      setIsSearchPage(true);
    } else {
      setIsSearchPage(false);
    }


    if (didMountRef.current) {
      if (getCookie("USER_TOKEN")) {

      } else {
        const uniqueId = crypto.randomUUID();
        setCookie("USER_TOKEN", uniqueId);
      }

    }
    didMountRef.current = false
  })

  return (
    <React.Fragment>
      <CartProvider>
        <Header isSearchPage={isSearchPage} carthandleShow={carthandleShow} />
        <Routes>

          <Route path="/" element={
            <Suspense fallback={<div></div>}>
              <LazyHomePage />
            </Suspense>
          }
          />
          <Route path="/shop" element={
            <Suspense fallback={<div></div>}>
              <LazyProducts />
            </Suspense>
          }
          />
          <Route path="/shop-dhanvi" element={
            <Suspense fallback={<div></div>}>
              <LazyShopDhanvi />
            </Suspense>
          }
          />
          <Route path="/shop-premio" element={
            <Suspense fallback={<div></div>}>
              <LazyShopPremio />
            </Suspense>
          }
          />
          <Route path="/shop/:category/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazyCategories />
            </Suspense>
          }
          />

          <Route
          path="/shop/category/:category/:slug"
          element={
            <Suspense fallback={<div></div>}>
              <LazyCategories />
            </Suspense>
          }
        />
         

           <Route path="/shop/:category/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazySubCategories />
            </Suspense>
          }
          />

          <Route path="/product/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazyProductDetail />
            </Suspense>
          }
          />
          <Route path="/categories" element={
            <Suspense fallback={<div></div>}>
              <LazyCategories />
            </Suspense>
          }
          />
          <Route path="/login" element={
            <Suspense fallback={<div></div>}>
              <LazyLogin />
            </Suspense>
          }
          />
          <Route path="/forgot-password" element={
            <Suspense fallback={<div></div>}>
              <LazyForgotPassword />
            </Suspense>
          }
          />
          <Route path="/new-password" element={
            <Suspense fallback={<div></div>}>
              <LazyNewPassword />
            </Suspense>
          }
          />
          {/* <Route path="/size-guide-1" element={
            <Suspense fallback={<div></div>}>
              <LazySizeGuide />
            </Suspense>
          }
          /> */}
          <Route path="/about" element={
            <Suspense fallback={<div></div>}>
              <LazyAbout />
            </Suspense>
          }
          />
          {/* <Route path="/about-dhanvi-2" element={
            <Suspense fallback={<div></div>}>
              <LazyAboutDhanvi />
            </Suspense>
          }
          /> */}
          <Route path="/bespoke" element={
            <Suspense fallback={<div></div>}>
              <LazyBespoke />
            </Suspense>
          }
          />
          <Route path="/contact" element={
            <Suspense fallback={<div></div>}>
              <LazyContact />
            </Suspense>
          }
          />
          <Route path="/wish-list" element={
            <Suspense fallback={<div></div>}>
              <LazyCartWishList />
            </Suspense>
          }
          />
          <Route path="/cart" element={
            <Suspense fallback={<div></div>}>
              <LazyCart />
            </Suspense>
          }
          />

          <Route path="/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazyPage />
            </Suspense>
          }
          />
          <Route path="blogs" element={
            <Suspense fallback={<div></div>}>
              <LazyBlog />
            </Suspense>
          }
          />
          <Route path="/blog-details/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazyBlogsDetail />
            </Suspense>
          }
          />
          {/* <Route path="/faqs" element={
            <Suspense fallback={<div></div>}>
              <LazyFaqs />
            </Suspense>
          }
          /> */}
          {/* <Route path="/jewellery-care-1" element={
            <Suspense fallback={<div></div>}>
              <LazyJewelleryCare />
            </Suspense>
          }
          /> */}
          <Route path="/checkout" element={
            <Suspense fallback={<div></div>}>
              <LazyCheckout />
            </Suspense>
          }
          />
          {/* <Route path="/franchise-2" element={
            <Suspense fallback={<div></div>}>
              <LazyFranchise />
            </Suspense>
          }
          /> */}
          <Route path="/search" element={
            <Suspense fallback={<div></div>}>
              <LazySearch />
            </Suspense>
          }
          />
          <Route path="/search/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazySearchList />
            </Suspense>
          }
          />
          <Route path="/trade" element={
            <Suspense fallback={<div></div>}>
              <LazyTrade />
            </Suspense>
          }
          />
          {/* <Route path="/testimonial" element={
            <Suspense fallback={<div></div>}>
              <LazyTestimonial />
            </Suspense>
          }
          /> */}
          <Route path="/my-account" element={
            <Suspense fallback={<div></div>}>
              <LazyMyAccount />
            </Suspense>
          }
          />
          <Route path="/my-orders" element={
            <Suspense fallback={<div></div>}>
              <LazyMyOrders />
            </Suspense>
          }
          />
          <Route path="/my-wishlist" element={
            <Suspense fallback={<div></div>}>
              <LazyMyWishlist />
            </Suspense>
          }
          />
          <Route path="/address-book" element={
            <Suspense fallback={<div></div>}>
              <LazyAddressBook />
            </Suspense>
          }
          />
          <Route path="/account-information" element={
            <Suspense fallback={<div></div>}>
              <LazyAccountInformation />
            </Suspense>
          }
          />
          <Route path="/change-password" element={
            <Suspense fallback={<div></div>}>
              <LazyChangePassword />
            </Suspense>
          }
          />
          <Route path="/business-login" element={
            <Suspense fallback={<div></div>}>
              <LazyBLogin />
            </Suspense>
          }
          />
          <Route path="/business-signup" element={
            <Suspense fallback={<div></div>}>
              <LazyBSignup />
            </Suspense>
          }
          />
          <Route path="/wishList" element={
            <Suspense fallback={<div></div>}>
              <LazyWishList />
            </Suspense>
          }
          />

          <Route path="/thankyou/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazyThankyou />
            </Suspense>
          }
          />
          <Route path="/enquiry-request/:slug?" element={
            <Suspense fallback={<div></div>}>
              <LazyPurchaseOrder />
            </Suspense>
          }
          />
          <Route path="/events" element={
            <Suspense fallback={<div></div>}>
              <LazyEventListing />
            </Suspense>
          }
          />
          <Route path="/event-details/:slug" element={
            <Suspense fallback={<div></div>}>
              <LazyEventDetail />
            </Suspense>
          }
          />

        </Routes>
        <Footer isSearchPage={isSearchPage} />
      </CartProvider>
    </React.Fragment>
  );
}

export default App;
